import React, { useEffect } from "react";
import styled from "styled-components";

const sections = [
  {
    title: "WindRadar PRO x Plano Gratuito - Perguntas frequentes",
    items: [
      {
        question: "Existe um plano grátis?",
        answer: [
          "Sim. O WindRadar continua tendo uma versão grátis.",
          "Quem usa o plano gratuito pode acessar todas as estações patrocinadas e usar várias funções do app normalmente.",
          "Mesmo sem ser PRO, você pode explorar o mapa, ver previsão, consultar maré, postar, anunciar equipamentos, buscar locais e acompanhar bastante coisa pra planejar o velejo.",
        ],
      },
      {
        question: "Quem é grátis pode visualizar o vento ao vivo?",
        answer: [
          "Sim, mas parcialmente. Quem é grátis pode ver a média do vento e a rajada da última hora.",
        ],
      },
      {
        question: "Qual o critério para uma estação ser grátis ou PRO?",
        answer: ["O WindRadar trabalha com dois tipos principais de estação:"],
        bullets: [
          "Estação patrocinada: existe uma marca ou parceiro ajudando a manter aquela estação funcionando todo mês.",
          "Estação não patrocinada: aquela estação ainda não tem um parceiro pagando a manutenção mensal.",
          "Estações patrocinadas ficam liberadas para todo mundo.",
          "Estações não patrocinadas ficam disponíveis apenas para quem é PRO.",
          "Quando uma marca apoia a estação, a galera toda ganha acesso. Quando não existe esse apoio mensal, o acesso entra no plano PRO para ajudar a manter a rede funcionando.",
        ],
      },
      {
        question: "Por que algumas estações e câmeras estão off-line?",
        answer: [
          "Porque o WindRadar é vento ao vivo de verdade, não é só previsão.",
          "A gente mostra o vento através de equipamentos instalados em vários lugares do Brasil e também da Europa. Pra isso funcionar bem, dependemos de internet, energia elétrica, instalação correta e apoio dos parceiros em cada local.",
          "Às vezes uma estação ou câmera pode ficar off por causa de queda de energia, problema de internet, manutenção, mau tempo, ajuste no equipamento ou alguma situação no local.",
          "Quando isso acontece, a gente corre atrás pra resolver. Se você conhece algum parceiro ou local com equipamento off-line, chama a gente. Vamos fazer o possível pra colocar tudo no ar de novo.",
        ],
      },
      {
        question:
          "Tem uma estação em um ponto quebrada, mas mesmo assim ela aparece online no app, porque?",
        answer: [
          "Quando existem muitas estações próximas umas das outras, o sistema pode exibir online mesmo esta estando com problemas.",
          "A inteligência do sistema copia os dados das estações vizinhas para manter o máximo de disponibilidade.",
        ],
      },
      {
        question: "Quais as vantagens de ser PRO?",
        answer: [
          "Quem é PRO tem acesso completo ao WindRadar, sem anúncios obrigatórios e sem as principais limitações do plano grátis.",
          "Com o PRO, você pode:",
        ],
        bullets: [
          "Acessar todas as estações disponíveis.",
          "Ver o vento ao vivo, em tempo real.",
          "Assistir às câmeras ao vivo.",
          "Usar o app sem propaganda obrigatória.",
          "Registrar seus equipamentos sem o limite do plano gratuito.",
          "É o plano pra quem quer acompanhar o vento de perto, escolher melhor o pico e não perder a janela boa.",
        ],
      },
      {
        question: "Quem usa o plano gratuito tem quais acessos?",
        answer: [
          "Quem usa o WindRadar grátis também pode aproveitar bastante o app, mas com algumas limitações:",
        ],
        bullets: [
          "Visualiza anúncios obrigatórios durante o uso.",
          "Acessa as estações patrocinadas.",
          "Algumas estações ficam bloqueadas e disponíveis apenas para PRO.",
          "As medições das estações aparecem com atraso de 1 hora.",
          "Não tem acesso às câmeras ao vivo.",
          "Pode registrar no máximo 2 equipamentos.",
        ],
      },
      {
        question:
          "O usuário gratuito consegue ver as medições das estações de vento?",
        answer: [
          "Sim, mas com atraso de 1 hora.",
          "Pra ver o vento ao vivo, em tempo real, é preciso ser PRO.",
        ],
      },
      {
        question: "O usuário gratuito pode instalar o app?",
        answer: [
          "Sim. Pode instalar e usar normalmente.",
          "O app continua aberto para todo mundo. Mesmo no plano grátis, você consegue postar, ver previsão, consultar maré, anunciar equipamentos, explorar o mapa, buscar locais e usar boa parte dos recursos do WindRadar.",
        ],
      },
      {
        question:
          "O usuário gratuito consegue ver as medições das estações de vento?",
        answer: [
          "Sim, mas com atraso de 1 hora.",
          "Pra ver o vento ao vivo, em tempo real, é preciso ser PRO.",
        ],
      },
      {
        question: "A assinatura vale só até o final do ano ou por 12 meses?",
        answer: [
          "A assinatura vale por 12 meses a partir da data da assinatura.",
          "Por exemplo: se você assinar em junho, seu acesso PRO fica válido até junho do ano seguinte.",
        ],
      },
      {
        question: "O usuário gratuito pode ver as câmeras?",
        answer: ["Não. As câmeras ao vivo são exclusivas para quem é PRO."],
      },
      {
        question: "Por que assinar o PRO?",
        answer: [
          "Porque quem veleja sabe: o vento muda rápido.",
          "Às vezes uma hora faz toda diferença entre perder a sessão ou acertar aquele velejo perfeito.",
          "Além de liberar a experiência completa, sua assinatura ajuda o WindRadar a manter as estações funcionando, instalar novos equipamentos e levar vento ao vivo pra mais lugares.",
          "Bora fortalecer essa rede e seguir espalhando vento bom por aí. 🌬️🔥",
        ],
      },
    ],
  },
];

const introMessages = [
  "Valeu, big rider! 🌬️💙",
  "Obrigado por fazer parte desse sonho.",
  "Ter o vento ao vivo, a qualquer hora e em qualquer lugar, é muito mais do que tecnologia. É liberdade. É poder escolher melhor o momento de cair na água, velejar com mais segurança e aproveitar melhor cada sessão.",
  "Assinando o WindRadar PRO, você ajuda o WindRadar a continuar evoluindo, instalando novas estações, mantendo os equipamentos no ar e levando vento ao vivo para quem vive essa paixão de verdade.",
];

const Page = styled.main`
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 82% 4%,
      rgba(255, 255, 255, 0.24),
      transparent 28rem
    ),
    linear-gradient(180deg, #0574ff 0%, #005bea 48%, #003cc9 100%);
  color: #ffffff;
  font-family: Montserrat, Arial, sans-serif;
  overflow-x: hidden;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

const Hero = styled.header`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 38px) clamp(14px, 4vw, 22px) clamp(20px, 4vw, 28px);

  &::before {
    content: "";
    position: absolute;
    top: -115px;
    right: -95px;
    width: 430px;
    height: 430px;
    border: 42px solid rgba(255, 255, 255, 0.18);
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
    transform: rotate(22deg);
  }

  @media (max-width: 640px) {
    padding: 24px 14px 20px;

    &::before {
      top: -92px;
      right: -142px;
      width: 320px;
      height: 320px;
      border-width: 32px;
    }
  }
`;

const LogoWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 214px;
  height: 214px;
  padding: 22px;
  background: #0062ff;
  border-radius: 8px;
  box-shadow: 0 18px 40px rgba(0, 31, 120, 0.2);

  img {
    display: block;
    width: 74px;
    height: auto;
    margin-bottom: 12px;
  }

  span {
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -1px;
  }

  @media (max-width: 640px) {
    width: 156px;
    height: 156px;
    padding: 16px;

    img {
      width: 52px;
      margin-bottom: 10px;
    }

    span {
      font-size: 30px;
    }
  }
`;

const HeroTitle = styled.h1`
  position: relative;
  max-width: 880px;
  margin: 42px 0 14px;
  font-size: clamp(38px, 9vw, 86px);
  line-height: 0.92;
  font-weight: 800;

  @media (max-width: 640px) {
    margin-top: 30px;
  }

  @media (max-width: 380px) {
    font-size: 34px;
  }
`;

const Highlight = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 4px clamp(8px, 3vw, 14px) 9px;
  background: #004dff;
`;

const Intro = styled.p`
  position: relative;
  max-width: 720px;
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 19px;
  line-height: 1.45;
  font-weight: 600;

  @media (max-width: 640px) {
    font-size: 16px;
    padding-right: 6px;
  }
`;

const RepresentativesLink = styled.a`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  margin-top: 28px;
  padding: 0 26px;
  border: 2px solid rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  background: #06c767;
  color: #ffffff;
  font-size: 17px;
  font-weight: 800;
  text-decoration: none;
  box-shadow:
    0 20px 46px rgba(0, 31, 120, 0.34),
    0 0 0 7px rgba(255, 255, 255, 0.16);
  transition:
    background 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;

  &:hover,
  &:focus {
    background: #05b85f;
    border-color: #ffffff;
    color: #ffffff;
    box-shadow:
      0 24px 54px rgba(0, 31, 120, 0.42),
      0 0 0 9px rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`;

const Content = styled.section`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 clamp(14px, 4vw, 22px) 42px;

  @media (max-width: 640px) {
    padding: 0 14px 28px;
  }

  @media (max-width: 380px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Panel = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.96);
  color: #0a2360;
  border-radius: 8px;
  box-shadow: 0 26px 70px rgba(0, 34, 124, 0.24);
  overflow: hidden;
  width: 100%;
`;

const SectionBlock = styled.section`
  position: relative;
  padding: 24px clamp(16px, 4vw, 28px);
  border-bottom: 1px solid #dbe6ff;

  &:last-of-type {
    border-bottom: 0;
  }
`;

const IntroBlock = styled.section`
  position: relative;
  padding: 24px clamp(16px, 4vw, 28px);
  border-bottom: 1px solid #dbe6ff;
`;

const SectionTitle = styled.h2`
  margin: 0 0 18px;
  color: #001f73;
  font-size: clamp(24px, 4vw, 38px);
  line-height: 1.05;
  font-weight: 800;
`;

const FaqGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const QuestionCard = styled.article`
  min-width: 0;
  padding: 18px;
  border: 1px solid #dbe6ff;
  border-radius: 8px;
  background: #f7fbff;
`;

const Question = styled.h3`
  margin: 0 0 12px;
  color: #0062ff;
  font-size: 18px;
  line-height: 1.25;
  font-weight: 800;
`;

const Answer = styled.p`
  margin: 0 0 10px;
  color: #24406f;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 650;

  &:last-child {
    margin-bottom: 0;
  }
`;

const IntroAnswer = styled(Answer)`
  max-width: 860px;
  font-size: 17px;

  &:first-child {
    color: #001f73;
    font-size: clamp(24px, 4vw, 34px);
    line-height: 1.08;
    font-weight: 800;
  }
`;

const BulletList = styled.ul`
  margin: 10px 0 0;
  padding-left: 20px;
  color: #24406f;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 650;
`;

const Wave = styled.div`
  position: absolute;
  right: -65px;
  bottom: -110px;
  width: 260px;
  height: 260px;
  border: 28px solid rgba(0, 98, 255, 0.08);
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-radius: 50%;
  pointer-events: none;
`;

export default function Faq() {
  useEffect(() => {
    document.title = "WindRadar - FAQ";
  }, []);

  return (
    <Page>
      <Hero>
        <LogoWrap>
          <img src="Untitled.png" alt="" aria-hidden="true" />
          <span>windradar</span>
        </LogoWrap>
        <HeroTitle>
          FAQ <Highlight>WindRadar PRO</Highlight>
        </HeroTitle>
        <Intro>
          Entenda as diferenças entre o plano gratuito e o acesso PRO do
          WindRadar.
        </Intro>
        <RepresentativesLink href="/representantes">
          Assinar Agora! Direto com um representante
        </RepresentativesLink>
      </Hero>

      <Content>
        <Panel>
          <IntroBlock>
            {introMessages.map((message) => (
              <IntroAnswer key={message}>{message}</IntroAnswer>
            ))}
          </IntroBlock>
          {sections.map((section) => (
            <SectionBlock key={section.title}>
              <SectionTitle>{section.title}</SectionTitle>
              <FaqGrid>
                {section.items.map((item) => (
                  <QuestionCard key={item.question}>
                    <Question>{item.question}</Question>
                    {item.answer.map((paragraph) => (
                      <Answer key={paragraph}>{paragraph}</Answer>
                    ))}
                    {item.bullets ? (
                      <BulletList>
                        {item.bullets.map((bullet) => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </BulletList>
                    ) : null}
                  </QuestionCard>
                ))}
              </FaqGrid>
            </SectionBlock>
          ))}
          <Wave />
        </Panel>
      </Content>
    </Page>
  );
}
